// ورودی‌های عددیِ مبلغ (AntD InputNumber) — نمایشِ سه‌رقمیِ فارسی + پارسِ مقاوم.
//
// گاتچا: formatterِ فارسی («۱۰,۰۰۰») با parserِ /[^\d]/ ناسازگار است؛ چون \d فقط
// رقمِ ASCII را می‌گیرد و ارقامِ فارسیِ نمایش‌داده‌شده را پاک می‌کند ⇒ فیلد خالی می‌ماند.
// این پارسر اول ارقام را انگلیسی می‌کند و undefined را هم امن هندل می‌کند.
import { toEnglishDigits } from "./digitNormalizer";
import { faNum } from "./faNumberFormat";

/** ۱۲۳۴۵ → «۱۲,۳۴۵» (بدون اعشار؛ ذخیره همچنان عددی است) */
export const moneyFormatter = (v) => {
  if (v === "" || v === null || v === undefined) return "";
  const n = Math.round(Number(v));
  return Number.isFinite(n) ? faNum(n) : "";
};

/** «۱۲,۳۴۵» یا «12,345» → «12345» */
export const moneyParser = (v) => {
  const s = toEnglishDigits(v ?? "").replace(/[^\d.]/g, "");
  const parts = s.split(".");
  return parts.length > 2 ? `${parts[0]}.${parts.slice(1).join("")}` : s;
};
